import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideDownloadDetails } from '../actions';
import { Button, Modal } from 'semantic-ui-react';
//noinspection ES6CheckImport
import { listGroups, searchContent } from '@plone/volto/actions';
import DocxFileViewer from './DocxFileViewer';
import ExcelFileViewer from './ExcelFileViewer';
import PDFFileViewer from './PDFFileViewer';
import { flattenToAppURL } from '@plone/volto/helpers';

const MIMETypes = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  image: 'image',
};

const DownloadButton = (props) => {
  return (
    <a className={'btn primary download-link'} href={props.url}>
      Herunterladen
    </a>
  );
};

const DownloadDetailsModal = () => {
  const dispatch = useDispatch();
  const uid = useSelector((store) => store?.downloaddetails?.uid || '');
  const items = useSelector((state) => state?.search?.subrequests?.downloadItems?.items || {});

  useEffect(() => {
    if (uid) {
      dispatch(
        searchContent(
          '/medien',
          {
            UID: uid,
            fullobjects: true,
          },
          'downloadItems',
        ),
      );
    }
    dispatch(listGroups());
  }, [dispatch, uid]);

  const getMIMEType = () => {
    if (items[0]?.['@type'] === 'File') {
      return items[0]?.file?.['content-type'];
    }

    return 'image';
  };

  const getDownloadLink = () => {
    if (items[0]?.['@type'] === 'File') {
      return items[0]?.file?.download;
    }

    return items[0]?.image?.download;
  };

  const mimeType = getMIMEType();

  return (
    <Modal open={!!uid} className={'download-details-modal'} size={'large'}>
      <Modal.Header>
        {items[0]?.title}
        <Button
          basic
          circular
          secondary
          icon="remove"
          floated={'right'}
          aria-label="Vorschau schließen"
          title="Vorschau schließen"
          onClick={() => dispatch(hideDownloadDetails())}
        />
      </Modal.Header>
      {items ? (
        <Modal.Content>
          <div className="documentviewer">
            {mimeType === MIMETypes.docx ? (
              <div>
                <DocxFileViewer fileURL={getDownloadLink()} />
                <DownloadButton url={getDownloadLink()} />
              </div>
            ) : mimeType === MIMETypes.xls || mimeType === MIMETypes.xlsx ? (
              <div>
                <ExcelFileViewer fileURL={getDownloadLink()} />
                <DownloadButton url={getDownloadLink()} />
              </div>
            ) : mimeType === MIMETypes.image ? (
              <div>
                {/* eslint-disable-next-line no-restricted-syntax -- plain img is fine for the modal preview */}
                <img src={flattenToAppURL(items[0]?.['@id']) + '/@@images/image'} alt={items[0]?.title} />
                <a className={'btn primary'} href={getDownloadLink()}>
                  In voller Größe anzeigen
                </a>
              </div>
            ) : mimeType === MIMETypes.pdf ? (
              <div>
                <PDFFileViewer
                  data={{
                    url: getDownloadLink(),
                    hideToolbar: false,
                    hideNavbar: false,
                    showPagesPreview: true,
                    initialPage: 1,
                    initial_scale: 1.0,
                    initial_scale_ratio: 0,
                    disableScroll: false,
                    fitPageWidth: false,
                  }}
                />
                <DownloadButton url={getDownloadLink()} />
              </div>
            ) : (
              <div>
                <h3>Dieser Dateityp wird aktuell nicht unterstützt.</h3>
                <DownloadButton url={getDownloadLink()} />
              </div>
            )}
          </div>
        </Modal.Content>
      ) : (
        <Modal.Content>
          <h2>Kein Inhalt gefunden!</h2>
        </Modal.Content>
      )}
    </Modal>
  );
};

export { DownloadButton, DownloadDetailsModal as default };
